<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Hero -->
  <app-careers-hero-section />
  <!-- Values -->
  <app-careers-values-section />
  <!-- Benefits -->
  <app-careers-benefits-section />
  <!-- Jobs -->
  <app-careers-jobs-section />
</div>
